.tenantList {
  h3 {
    font: var(--font-title-3);
    color: var(--color-text-secondary);
  }
}
